import HttpService from "./httpService";
import {
  authStorageKey,
  userDetailsStorageKey,
  userMenuStorageKey,
  apiRoot,
  authMethode,
  validateDeviceForLogin,
  setJobId,
  jobId,
  useExternalLoginProviders,
  externalLoginProviderName,
} from "../General/globals";
import StorageService from "./storageService";
import ServiceBase from "./_serviceBase";
import {
  authLogin,
  authLogout,
  hideAppBusy,
  authSessionActive,
} from "../AppOwnState";
import { ownStore } from "../AppOwnState/ownState";

// import Axios from "axios";

class AuthService extends ServiceBase {
  constructor(authPath, authBody) {
    super();
    this.authPath = authPath;
    this.authBody = authBody;
    this.state = {
      jobId: null,
    };
  }

  async login(client_id, client_secret, remember_me, jobId) {
    let eCS = encodeURIComponent(client_secret);
    this.state.jobId = jobId;
    setJobId(jobId);

    let requestBody = `grant_type=${this.authBody.grant_type}&hash_method=${
      this.authBody.hash_method
    }&job_id=${
      jobId || this.authBody.job_id
    }&client_id=${client_id}&client_secret=${eCS}&provider=${externalLoginProviderName}`;

    let headers = {};
    headers["Content-Type"] = "application/x-www-form-urlencoded";

    let json = await new HttpService().postServer(
      apiRoot,
      this.authPath,
      headers,
      requestBody
    );
    let fullURL = apiRoot + this.authPath;
    json = await this.manageOfflineData(
      undefined,
      { fullURL, requestBody },
      json
    );

    if (json && json.access_token) {
      let stService = new StorageService();
      stService.setStatePersistance(remember_me);
      stService.setJsonValue(authStorageKey, {
        at: json.access_token,
        tt: json.token_type,
        ei: json.expires_in,
        rt: json.refresh_token,
        tm: new Date(),
      });
    } else {
      console.log("Login Failed");
    }
  }

  async logout() {
    let [currentToken, isTokenNeeded] = this.getStoredToken();

    if (currentToken || !isTokenNeeded) {
      await this.loadFromServer(
        jobId || this.authBody.job_id,
        "PWA.UserLogout",
        currentToken?.at,
        { info: currentToken?.at }
      );
    }
    let stService = new StorageService();
    stService.clearStorage(authStorageKey);
    stService.clearStorage(userDetailsStorageKey);
    stService.clearStorage(userMenuStorageKey);
    // SetCreateDataSet({ dset: "pageinfo" }, null);
    ownStore.dispatch(authLogout()); //Redux
  }

  async SSOlogin(client_id, client_secret) {
    let requestBody = `grant_type=${
      this.authBody.grant_type
    }&source=SSO&hash_method=${this.authBody.hash_method}&job_id=${
      jobId || this.authBody.job_id
    }&client_id=${client_id}&client_secret=${client_secret}&provider=${externalLoginProviderName}`;

    let headers = {};
    headers["Content-Type"] = "application/x-www-form-urlencoded";

    let json = await new HttpService().postServer(
      apiRoot,
      this.authPath,
      headers,
      requestBody
    );
    let fullURL = apiRoot + this.authPath;
    json = await this.manageOfflineData(
      undefined,
      { fullURL, requestBody },
      json
    );

    if (json && json.access_token) {
      let stService = new StorageService();
      stService.setJsonValue(authStorageKey, {
        at: json.access_token,
        tt: json.token_type,
        ei: json.expires_in,
        rt: json.refresh_token ?? null,
        tm: new Date(),
      });
    } else {
      console.log("Login Failed");
    }
  }

  getStoredToken() {
    if (authMethode === "cookie") return [null, false];
    //Cookie Authentication; No token needed
    else {
      let currentToken = new StorageService().getJsonValue(authStorageKey);
      return [currentToken, true];
    }
  }

  async verifyLogin() {
    let [currentToken, isTokenNeeded] = this.getStoredToken();

    if (isTokenNeeded && !currentToken) return null;
    let json = await this.loadFromServer(
      jobId || this.authBody.job_id,
      "PWA.VerifyAuth",
      currentToken?.at,
      { info: currentToken?.at }
    );
    if (json && json.length > 0 && json[0].status === "true")
      return { status: true, doNext: json[0].doNext };
    return { status: false };
  }

  async continueLogin() {
    //Seeperated from Main logic  for Two factor Authentication
    let _userDetails = await this.getCurrentUserDetails();
    if (!_userDetails) {
      ownStore.dispatch(hideAppBusy());
      throw new Error("No Such User!");
    }
    await this.loadUserSpecificMenu(_userDetails.userrole);

    ownStore.dispatch(authLogin()); //Redux
    ownStore.dispatch(authSessionActive()); //Redux
    ownStore.dispatch(hideAppBusy());
  }

  async getCurrentUserDetails() {
    let userDetails = await this.loadUserDetails();

    if (userDetails && userDetails.length > 0) {
      new StorageService().setJsonValue(userDetailsStorageKey, userDetails[0]);
      return userDetails[0];
    }
    return null;
  }

  async loadUserDetails() {
    let [currentToken, isTokenNeeded] = this.getStoredToken();
    const DB_NAME = "authDB";
    const STORE_NAME = "device";
    const KEY = "deviceId";

    function generateUUID() {
      return crypto.randomUUID();
    }

    function getOrCreateDeviceId() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);

        request.onerror = () => reject("IndexedDB not available");

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
          }
        };

        request.onsuccess = () => {
          const db = request.result;
          const tx = db.transaction(STORE_NAME, "readwrite");
          const store = tx.objectStore(STORE_NAME);
          const getReq = store.get(KEY);

          getReq.onsuccess = () => {
            let deviceId = getReq.result;
            if (!deviceId) {
              deviceId = generateUUID();
              store.add(deviceId, KEY);
            }
            localStorage.setItem("dev_id", deviceId);
            resolve(deviceId);
          };

          getReq.onerror = () => reject("Error reading deviceId");
        };
      });
    }

    async function init() {
      const deviceID = await getOrCreateDeviceId();
      return deviceID;
    }

    async function getDeviceDetails() {
      const userAgent = navigator.userAgent;

      const browsers = [
        {
          name: "Brave",
          test: async () =>
            !!navigator.brave && (await navigator.brave.isBrave()) === true,
          versionRegex: /Chrome\/([0-9.]+)/,
        },
        {
          name: "Yandex Browser",
          test: /YaBrowser/,
          versionRegex: /YaBrowser\/([0-9.]+)/,
        },
        {
          name: "Microsoft Edge",
          test: /Edg/,
          versionRegex: /Edg\/([0-9.]+)/,
        },
        {
          name: "Mozilla Firefox",
          test: /Firefox/,
          versionRegex: /Firefox\/([0-9.]+)/,
        },
        {
          name: "Opera",
          test: /Opera|OPR/,
          versionRegex: /(?:Opera|OPR)\/([0-9.]+)/,
        },
        {
          name: "Vivaldi",
          test: /Vivaldi/,
          versionRegex: /Vivaldi\/([0-9.]+)/,
        },
        {
          name: "DuckDuckGo Browser",
          test: /DuckDuckGo/,
          versionRegex: /DuckDuckGo\/([0-9.]+)/,
        },
        {
          name: "Tor Browser",
          test: /TorBrowser/,
          versionRegex: /TorBrowser\/([0-9.]+)/,
        },
        {
          name: "UC Browser",
          test: /UCBrowser/,
          versionRegex: /UCBrowser\/([0-9.]+)/,
        },
        {
          name: "Samsung Internet",
          test: /SamsungBrowser/,
          versionRegex: /SamsungBrowser\/([0-9.]+)/,
        },
        {
          name: "QQ Browser",
          test: /QQBrowser/,
          versionRegex: /QQBrowser\/([0-9.]+)/,
        },
        {
          name: "Baidu Browser",
          test: /BaiduBrowser/,
          versionRegex: /BaiduBrowser\/([0-9.]+)/,
        },
        {
          name: "Amazon Silk",
          test: /Silk/,
          versionRegex: /Silk\/([0-9.]+)/,
        },
        {
          name: "Vivo Browser",
          test: /VivoBrowser/,
          versionRegex: /VivoBrowser\/([0-9.]+)/,
        },
        {
          name: "Miui Browser",
          test: /MiuiBrowser/,
          versionRegex: /MiuiBrowser\/([0-9.]+)/,
        },
        {
          name: "Google Chrome",
          test: /Chrome(?!.*(?:Edg|Brave|YaBrowser))/,
          versionRegex: /Chrome\/([0-9.]+)/,
        },
        {
          name: "Safari",
          test: /Safari(?!.*Chrome)/,
          versionRegex: /Version\/([0-9.]+)/,
        },
      ];

      const getVersion = (regex) => {
        const match = userAgent.match(regex);
        return match ? match[1] : "Unknown Version";
      };

      const detectOS = () => {
        const osMatchers = [
          { name: "Windows", regex: /Windows NT ([0-9.]+)/ },
          { name: "macOS", regex: /Mac OS X ([0-9_]+)/ },
          { name: "Linux", regex: /Linux/ },
          { name: "iOS", regex: /iPhone|iPad/ },
          { name: "Android", regex: /Android ([0-9.]+)/ },
        ];

        for (const os of osMatchers) {
          const match = userAgent.match(os.regex);
          if (match) {
            return {
              name: os.name,
              version: match[1]?.replace(/_/g, ".") || "Unknown Version",
            };
          }
        }
        return { name: "Unknown OS", version: "Unknown Version" };
      };

      const detectDeviceType = () => {
        const ua = userAgent.toLowerCase();
        if (/tablet|ipad/i.test(ua)) return "tablet";
        if (/mobi|android|iphone|windows phone/i.test(ua)) return "mobile";
        return "desktop";
      };

      const getIP = async () => {
        try {
          const res = await fetch("https://api.ipify.org?format=json");
          const data = await res.json();
          return data.ip;
        } catch {
          return null;
        }
      };

      let detectedBrowser = {
        name: "Unknown Browser",
        version: "Unknown Version",
      };
      for (const browser of browsers) {
        const isMatch =
          typeof browser.test === "function"
            ? await browser.test()
            : browser.test.test(userAgent);

        if (isMatch) {
          detectedBrowser = {
            name: browser.name,
            version: getVersion(browser.versionRegex),
          };
          break;
        }
      }

      const [ip, os, deviceType] = await Promise.all([
        getIP(),
        detectOS(),
        detectDeviceType(),
      ]);

      return {
        browser: detectedBrowser,
        os,
        deviceType,
        ip,
      };
    }

    const deviceData = await getDeviceDetails();

    const UID = await init();

    if (isTokenNeeded && !currentToken) return null;

    const body = {
      info: currentToken?.at,
      deviceId: UID,
      validateDevice: validateDeviceForLogin ? 1 : 0,
      deviceData,
    };

    const data = await this.loadFromServer(
      jobId || this.authBody.job_id,
      "PWA.GetUserDetails",
      currentToken?.at,
      body
    );

    const userRegDeviceId = data?.[0]?.DID;
    if (validateDeviceForLogin && UID !== userRegDeviceId) {
      alert("Device not recognized. Please log in using a registered device.");
      return {};
    }
    return data;
  }

  async loadUserSpecificMenu(_userrole) {
    let _userMenu = await this.loadUserMenu({ userrole: _userrole });
    new StorageService().setJsonValue(userMenuStorageKey, _userMenu);

    // if (userDetails && userDetails.length > 0) {
    //     new StorageService().setJsonValue(userDetailsStorageKey, userDetails[0]);
    //     return true;
    // }
    // return false;
  }
  async loadUserMenu(userRole) {
    let [currentToken, isTokenNeeded] = this.getStoredToken();

    if (isTokenNeeded && !currentToken) return null;
    return await this.loadFromServer(
      jobId || this.authBody.job_id,
      "PWA.GetUserMenu",
      currentToken?.at,
      { info: userRole }
    );
  }
}

export default AuthService;
